module.exports = __webpack_public_path__ + "static/media/mobile_shop.16eeab2c.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/img/web_apps/mobile_shop.jpg
// module id = 131
// module chunks = 0